import React from 'react'
import { useTranslation } from 'react-i18next'

const Content = () => {
    const { t } = useTranslation()
    return (
        <>
            <div className="story__section">
                <h1 className="story__section_hero">hustle.</h1>

                <div className="story__section_hero_subtext">
                    <span>hustler.</span> 
                    <span className="story__section_hero_subtext--bold">[huhs-ler]:</span> 
                    <span>noun, adj:</span>
                </div>
                
                <p className="story__section_text--small">
                    {t('storyboard__content_hero_definition')} • {t('storyboard__content_hero_definition_informal')} 
                    {t('storyboard__content_hero_definition_ext_1')}
                    {t('storyboard__content_hero_definition_ext_2')}
                    {t('storyboard__content_hero_definition_ext_3')}
                </p>
            </div>

            <div className="story__section">
                <h1 className="story__section_name">{t('storyboard__content_hero_name')}</h1>
            </div>
            <div className="story__section">
                <h2 className="story__section_intro">{t('storyboard__content_hero_intro')}</h2>
            </div>
            <div className="story__section" >
                <h3 className="story__section_text" >        
                    {t('storyboard__content_hero_text_1')}
                    <i>{t('storyboard__content_hero_text_2')}</i> 
                    {t('storyboard__content_hero_text_3')} <br/> 
                    {t('storyboard__content_hero_text_4')}<br />
                    <b>web dev</b>.
                </h3>
            </div>
        </> 
    )
}
export default Content